/** Shared bits for the Spend Leakage list and detail pages. */

export const statusColors: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-800',
  published: 'bg-green-100 text-green-800',
  archived: 'bg-gray-100 text-gray-500',
};

export const categoryOptions = [
  { value: 'off_contract', label: 'Off-Contract Purchase' },
  { value: 'maverick', label: 'Maverick Spending' },
  { value: 'emergency', label: 'Emergency Purchase' },
  { value: 'non_preferred', label: 'Non-Preferred Supplier' },
  { value: 'price_variance', label: 'Price Variance' },
  { value: 'other', label: 'Other' },
];

/** DRF serialises decimals as strings; the pages format either. */
export function toNumber(value: number | string | null | undefined): number {
  if (value === null || value === undefined) return 0;
  const n = typeof value === 'string' ? parseFloat(value) : value;
  return Number.isFinite(n) ? n : 0;
}

export function formatPercentage(value: number | string): string {
  return toNumber(value).toFixed(1);
}

/** True when a report carries the uploaded / not-uploaded split. */
export function hasUploadSplit(report: {
  uploaded_spend?: number | string;
  not_uploaded_spend?: number | string;
  uploaded_leakage?: number | string;
  not_uploaded_leakage?: number | string;
}): boolean {
  return (
    report.uploaded_spend !== undefined ||
    report.not_uploaded_spend !== undefined ||
    report.uploaded_leakage !== undefined ||
    report.not_uploaded_leakage !== undefined
  );
}
